import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';
import { HttpStatusCodeService } from 'ish-core/utils/http-status-code/http-status-code.service';

export const customRouteBlockGuard = (route: ActivatedRouteSnapshot) => {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);
  const httpStatusCodeService = inject(HttpStatusCodeService);

  if (featureToggleService.enabled(route.data.blockIfFeatureEnabled)) {
    httpStatusCodeService.setStatus(404, false);
    return router.createUrlTree(['/error'], {
      queryParams: {
        error: 'feature-deactivated',
        value: route.data.feature,
      },
    });
  }
  return true;
};
